import React, { useEffect, useState, Fragment } from "react";

import { Styles } from "../../config";
import { Flex, Grid } from "../../container-components";
import { IconButton, TileButton } from "../../element-components";
import store from "../../store";

const urlCreator = window.URL || window.webkitURL;

const ImageStream = (props) => {
  const { handleAddMedia, setIsMediaStream } = props;

  const [blobCapture, setBlobCapture] = useState(null);
  const videoCaptureRef = React.useRef(null);
  const mediaTrackStreamRef = React.useRef(null);
  const [submittingImage, setSubmittingImage] = useState(false);
  const [imageCapture, setImageCapture] = useState(null);

  const getMediaStream = async () => {
    try {
      let imageCaptureObj = {};
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false,
      });
      const mediaStreamTrack = mediaStream.getVideoTracks()[0];
      if ("ImageCapture" in window) {
        imageCaptureObj = new window.ImageCapture(mediaStreamTrack);
      }

      setImageCapture(imageCaptureObj);
      if (videoCaptureRef.current) {
        videoCaptureRef.current.srcObject = mediaStream;
      }
      mediaTrackStreamRef.current = mediaStreamTrack;
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getMediaStream();
  }, []);

  return (
    Boolean(imageCapture) && (
      <Fragment>
        <IconButton
          id="image-close"
          onClick={(e) => {
            e.preventDefault();
            setImageCapture(null);
            setBlobCapture(null);
            if (mediaTrackStreamRef.current) {
              mediaTrackStreamRef.current.stop();
              mediaTrackStreamRef.current = null;
            }
            videoCaptureRef.current = null;
            store.setNotification("alert", false, <div></div>);
          }}
          color="danger"
          iconConfig={{ name: "close" }}
          style={{
            position: "fixed",
            right: "15px",
            top: "15px",
            zIndex: 1003,
          }}
        />
        <Grid
          height="calc(100% - 95px)"
          column
          id="video-player"
          layout={[70, 30]}
          style={{
            maxWidth: "1600px",
            width: "90%",
            boxShadow: "1px 17px 64px -29px rgba(127,194,255,0.41)",
            maxHeight: "1000px",
            minHeight: "600px",
            padding: "20px",
            background: "#fff",
          }}
        >
          <Flex style={{ position: "relative", padding: "40px 0 0" }}>
            <canvas
              style={{
                position: "absolute",
                top: "0",
              }}
              id="image-canvas"
            />
            <video
              id="image-video"
              autoPlay
              ref={videoCaptureRef}
              onLoadedData={() => {
                if (!("ImageCapture" in window)) {
                  setImageCapture({
                    takePhoto: () =>
                      new Promise((resolve) => {
                        try {
                          const canvas = document.getElementById("image-canvas");
                          const context = canvas.getContext("2d");
                          const video = document.getElementById("image-video");

                          const { width, height } =
                            video.getBoundingClientRect();

                          canvas.width = width;
                          canvas.height = height;
                          context.drawImage(video, 0, 0, width, height);
                          canvas.toBlob(resolve, "image/png");
                        } catch (err) {
                          console.error(err);
                        }
                      }),
                  });
                }
              }}
              style={{
                height: "100%",
                width: "auto",
                position: "absolute",
                top: "0",
              }}
            />
          </Flex>
          <Flex
            style={{
              bottom: "0",
              padding: "20px 0",
              left: "0",
              background: "rgba(255,255,255, 0.1)",
            }}
          >
            <TileButton
              text="Capture"
              icon="photo_camera"
              color="secondary"
              type="button"
              onClick={async (e) => {
                e.stopPropagation();
                const img = document.getElementById("capture-img");
                const blob = await imageCapture.takePhoto();
                const imageUrl = urlCreator.createObjectURL(blob);
                img.src = imageUrl;
                setBlobCapture(blob);
              }}
            />
            <img
              id="capture-img"
              style={{
                width: "148px",
                height: "148px",
                objectFit: "contain",
                border: `3px solid ${Styles.Color.primary}`,
                margin: "0 20px",
              }}
            />
            <TileButton
              text="Confirm"
              color="secondary"
              type="button"
              disabled={!Boolean(blobCapture) || submittingImage}
              icon="check"
              onClick={async (e) => {
                e.stopPropagation();
                setSubmittingImage(true);
                await handleAddMedia({
                  files: [blobCapture],
                });
                setImageCapture(null);
                setBlobCapture(null);
                if (mediaTrackStreamRef.current) {
                  mediaTrackStreamRef.current.stop();
                  mediaTrackStreamRef.current = null;
                }
                videoCaptureRef.current = null;
                setSubmittingImage(false);
                store.setNotification("alert", false, <div />);
              }}
            />
          </Flex>
        </Grid>
      </Fragment>
    )
  );
};

export default ImageStream;
